<template>
  <vs-popup id="popupReject" title="" :active.sync="showPopup">
    <div class="p-4">
      <h3 class="text-center">회원가입을 거절하시겠습니까?</h3>
      <h5 class="text-center my-6">거절 사유</h5>
      <ml-textarea v-model="rejectReason" class="w-full" rows="5" placeholder="회원가입 거절 사유를 입력해주세요."/>

      <div class="mt-4 flex gap-2" style="justify-self: center;">
        <vs-button color="#AEB1B6" @click="showPopup = false">닫기</vs-button>
        <vs-button color="#EA5455" @click="handleClickReject">회원가입 거절</vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import InputForm from "@/views/pages/register/InputForm.vue";
import FileUploaderNoneToken from "@/components/FileUploaderNoneToken.vue";
import AddressField from "@/components/AddressField.vue";

export default {
  name: "PopupRejectJoinAccount",
  components: {AddressField, FileUploaderNoneToken, InputForm},
  props: {
    value: Boolean,
  },
  watch: {
    value(data) {
      this.showPopup = data;
    },
    showPopup(data) {
      this.$emit("input", data);
    },
  },
  data() {
    return {
      showPopup: false,
      rejectReason: '',
    }
  },
  methods: {
    handleClickReject() {
      this.$emit("reject", this.rejectReason);
      this.showPopup = false;
    },
  },
}
</script>

<style lang="scss" scoped>
.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem; /* Adjust the gap as needed */

  font-weight: 500;
  font-size: 14px;
}
.grid-item {
  //grid-column: span 2;
}

@media (max-width: 768px) {
  .grid-container {
    grid-template-columns: repeat(1, 1fr); /* 한 열로 변경 */
  }
}
</style>

<style lang="scss">
#popupCompany.con-vs-popup {
  z-index: 53000;

  .vs-popup {
    width: 70%;
    height: auto;

    position: relative;
  }
  .vs-popup--content {
    width: auto !important;
    padding: 1rem;
    font-size: 1rem;
  }
}
</style>
